import filtersKeys from 'constants/filters';
import { FilterTypes } from 'constants/FilterTypes';
import { QuickFilterConfig } from '../../types/QuickFilters';

export default (hasEditAccess: boolean = false): QuickFilterConfig[] => {
  const config: QuickFilterConfig[] = [
    {
      filterId: filtersKeys.settlementId,
      type: FilterTypes.text,
      title: 'settlements.quickFilters.id',
      metric: 'settlements.fastFilter.id.enter',
    },
    {
      filterId: filtersKeys.settlementWalletAddress,
      type: FilterTypes.text,
      title: 'settlements.quickFilters.walletAddress',
      metric: 'settlements.fastFilter.walletAddress.enter',
    },
    {
      filterId: filtersKeys.settlementBalanceId,
      type: FilterTypes.select,
      valueType: 'string',
      dictionary: 'settlementBalanceUser',
      title: 'Balance',
      placeholder: 'Balance',
      metric: 'settlements.fastFilter.balanceId.enter',
    },
    {
      filterId: filtersKeys.settlementStatus,
      type: FilterTypes.select,
      valueType: 'string',
      dictionary: 'settlementStatus',
      title: 'settlements.quickFilters.status',
      placeholder: 'settlements.quickFilters.status.placeholder',
      metric: 'settlements.fastFilter.status.enter',
    },
    {
      filterId: filtersKeys.settlementDate,
      type: FilterTypes.dateSelect,
      title: 'settlements.quickFilters.completedDate',
      metricName: 'settlements.fastFilter.completedDate.enter',
    },
  ];

  if (hasEditAccess) {
    config.splice(4, 0, {
        filterId: filtersKeys.merchantId,
        type: FilterTypes.select,
        valueType: 'string',
        dictionary: 'userMerchant',
        title: 'settlements.quickFilters.merchant',
        placeholder: 'settlements.quickFilters.merchant',
        metric: 'settlements.fastFilter.merchant.enter',
      },
    );
  }

  return config;
}
